/**
 * MagazinDocument entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class MagazinDocument extends BaseModel {
    defaults() {
        return {
            // entity properties
            id: null,
            document_id: null,
            magazin_id: null,
            given_name: null,

            // view fields
            path: null,
            type: null,
            size: null,
            name: null,
            title: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            document_id: Number,
            magazin_id: Number,
        };
    }

    entityName() {
        return 'MagazinDocument';
    }
}

export class MagazinDocumentCollection extends BaseCollection {
    options() {
        return {
            model: MagazinDocument,
        };
    }

    entityName() {
        return 'MagazinDocument';
    }
}
